import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalMessageComponent } from '../../components/modal-message/modal-message.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'aig-new-password',
  imports: [ReactiveFormsModule, CommonModule, ModalMessageComponent],
  templateUrl: './new-password.component.html',
  styleUrl: './new-password.component.scss',
})
export class NewPasswordComponent implements OnInit {
  public IdUsuarioEncrypt: string = '';

  //#region CONSTRUCTOR
  constructor(private fb: FormBuilder, private route: ActivatedRoute,
    private router: Router, private AuthService: AuthService) {
    this.passwordForm = this.fb.group({
      passwordnew: [
        '',
        [
          Validators.required,
          Validators.minLength(8), // Mínimo 8 caracteres
          Validators.pattern(/[A-Z]/), // Al menos una mayúscula
          Validators.pattern(/[a-z]/), // Al menos una minúscula
          Validators.pattern(/[0-9]/), // Al menos un número
          Validators.pattern(/[@#$%&!]/), // Al menos un caracter especial
        ],
      ],
      passwordconfirm: ['', Validators.required],
    });
  }
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.IdUsuarioEncrypt = params.get("t") ||'';

    });
    if (this.IdUsuarioEncrypt.trim()) {
      // Llamar a la API con el parámetro recibido
      this.AuthService.checkCambiarPassword(this.IdUsuarioEncrypt).subscribe({
        next: (response) => {

          // Si la respuesta es válida, permanecer en la página
        },
        error: (err) => {

          // Redirigir si la API responde con Unauthorized o cualquier error
          this.router.navigate(["auth/login"]);
        },
      });
    } else {
      // Si no hay parámetro, redirigir
      this.router.navigate(["auth/login"]);
    }
  }
  //#endregion

  get passwordValid(): boolean {
    const control = this.passwordForm.get('passwordnew');
    return control?.valid ?? false;
  }
  get passwordsMatch(): boolean {
    return (
      this.passwordForm.get('passwordnew')?.value ===
      this.passwordForm.get('passwordconfirm')?.value
    );
  }

  passwordRequirements: string[] = [
    'Al menos una mayúscula',
    'Al menos una minúscula',
    'Al menos un número del 0 al 9',
    'Al menos un caracter especial como @#$%&!',
    'Mínimo de 8 caracteres',
  ];

  //#region PUBLIC METHODS
  public passwordForm: FormGroup = new FormGroup({});
  public showPasswordNew: boolean = false;
  public showPasswordRepeat: boolean = false;
  public visibleMessageModal: boolean = false;
  //#endregion

  public CloseModal() {
    this.visibleMessageModal = false;
    this.router.navigate(["auth/login"]);
  }

  public Send() {
    if (this.IdUsuarioEncrypt && this.passwordForm.get('passwordnew')?.value.trim()) {
      this.AuthService.cambiarPassword(
        this.IdUsuarioEncrypt,
        this.passwordForm.get('passwordnew')?.value
      ).subscribe({
        next: (response) => {

          // Redirigir a una página de éxito o mostrar un mensaje
          //this.router.navigate(["auth/login"]);
          this.visibleMessageModal = true;
        },
        error: (err) => {
          console.error("Error al cambiar la contraseña:", err);
          // Mostrar un mensaje de error al usuario
        },
      });
    }
    this.visibleMessageModal = true;
  }
}
